export default {
  props: {
    text: String
  },
  data: function data() {
    return {
      value: this.text,
      editable: false
    };
  },
  watch: {
    text: function text() {
      this.value = this.text;
    }
  },
  methods: {
    check: function check() {
      this.editable = false;
      this.$emit('change', this.value);
    },
    edit: function edit() {
      this.editable = true;
    }
  }
};